var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container mx-auto bg-dark-blue text-white p-10 text-xl border mb-4 rounded-lg"},[_c('span',{staticClass:"font-semibold"},[_vm._v("Goll Video.")]),_vm._v(" Wir liefern Ihnen diverse kurze Videos zu unteren Produkten, Montage und Produktion sowie\n  Anwendungsbeispiele usw.\n")])
}]

export { render, staticRenderFns }